import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../CsStyles";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { GenericFieldNames } from "../../../Constants";
import { Box, Grid, Item, TextField, Typography } from '@material-ui/core';

class Field extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Grid item>
                    <Typography variant='h6'>Set</Typography>
                </Grid>
                <Grid item xs>
                    <Autocomplete
                        disablePortal
                        style={{ width: '100%' }}
                        options={GenericFieldNames}
                        renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: false }} />}
                        value={this.props.name}
                        onChange={(e, v) => { this.props.funcs.setName(v); }}
                    />
                </Grid>
                <Grid item>
                    <Typography variant='h6'>To</Typography>
                </Grid>
                <Grid item xs>
                    <TextField InputLabelProps={{ shrink: false }} fullWidth onChange={e => this.props.funcs.setValue(e.target.value)} value={this.props.value} />
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(Field);